/**
 * @generated SignedSource<<04664d60bd93ff9e18a3d152e4594fc1>>
 * @relayHash a6a8a90250de16bb78d8ca00326d941c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3c47f7cfe398cac939613eb8205ec263cac33c524bb077af243c37c33a0efad6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavQueueQuery } from './HorizontalNavQueueQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavQueueQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3c47f7cfe398cac939613eb8205ec263cac33c524bb077af243c37c33a0efad6",
    "metadata": {},
    "name": "HorizontalNavQueueQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
